export default __webpack_public_path__ + "static/pexels-leah-kelley-618923-1f63c367a806486878f695cd95a14290.jpg";